<template>
  <div class="brand-lines" :class="{ 'brand-lines--fill-white': fillWhite, 'brand-lines--animate': animate }">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      :preserveAspectRatio="aspectRatio"
      viewBox="0 0 149.9 155.7"
      xml:space="preserve"
    >
      <g v-if="position === 'bottom-left'">
        <line class="brand-lines-2" x2="149.8" y2="127.7" x1="18.8" y1="137.8" />
        <line class="brand-lines-3" x2="149.8" y2="25.9" x1="18.8" y1="137.8" />
        <line class="brand-lines-4" x2="32.3" y2="0.1" x1="18.8" y1="137.8" />
        <line class="brand-lines-5" x1="18.8" y1="137.8" x2="0.1" y2="115.1" />
        <line class="brand-lines-6" x1="18.8" y1="137.8" x2="0.1" y2="137.7" />
        <line class="brand-lines-7" x1="18.8" y1="137.8" x2="8.3" y2="155.7" />
        <line class="brand-lines-0" x2="25.8" y2="155.7" x1="18.8" y1="137.8" />
        <line class="brand-lines-1" x2="50.8" y2="155.7" x1="18.8" y1="137.8" />
      </g>
      <g v-else-if="position === 'bottom-right'">
        <line class="brand-lines-0" x1="149.8" y1="121.4" x2="115.7" y2="134.8" />
        <line class="brand-lines-1" x1="149.8" y1="73.7" x2="115.7" y2="134.8" />
        <line class="brand-lines-2" x1="115.7" y1="134.8" x2="105.3" y2="0.1" />
        <line class="brand-lines-3" x1="115.7" y1="134.8" x2="0.7" y2="0.1" />
        <line class="brand-lines-4" x1="115.7" y1="134.8" x2="0.1" y2="123.4" />
        <line class="brand-lines-5" x1="115.7" y1="134.8" x2="90.2" y2="155.7" />
        <line class="brand-lines-6" x1="115.7" y1="134.8" x2="115.6" y2="155.7" />
        <line class="brand-lines-7" x1="149.8" y1="155.6" x2="115.7" y2="134.8" />
      </g>
      <g v-else-if="position === 'center-right'">
        <line class="brand-lines-0" x2="149.8" y2="63.8" x1="114" y1="77.8" />
        <line class="brand-lines-1" x2="149.8" y2="13.8" x1="114" y1="77.8" />
        <line class="brand-lines-2" x1="114" y1="77.8" x2="108" y2="0.2" />
        <line class="brand-lines-3" x1="114" y1="77.8" x2="47.6" y2="0.1" />
        <line class="brand-lines-4" x1="114" y1="77.8" x2="0.1" y2="66.6" />
        <line class="brand-lines-5" x1="114" y1="77.8" x2="19.3" y2="155.6" />
        <line class="brand-lines-6" x1="114" y1="77.8" x2="113.8" y2="155.6" />
        <line class="brand-lines-7" x2="149.8" y2="98.9" x1="114" y1="77.8" />
      </g>
      <g v-else>
        <line class="brand-lines-0" x2="149.8" y2="48.5" x1="74.9" y1="77.8" />
        <line class="brand-lines-1" x2="118.3" y2="0.1" x1="74.9" y1="77.8" />
        <line class="brand-lines-2" x2="68.9" y2="0.2" x1="74.9" y1="77.8" />
        <line class="brand-lines-3" x2="8.5" y2="0.1" x1="74.9" y1="77.8" />
        <line class="brand-lines-4" x2="0.1" y2="70.5" x1="74.9" y1="77.8" />
        <line class="brand-lines-5" x2="0.1" y2="139.2" x1="74.9" y1="77.8" />
        <line class="brand-lines-6" x2="74.6" y2="155.6" x1="74.9" y1="77.8" />
        <line class="brand-lines-7" x2="149.8" y2="121.9" x1="74.9" y1="77.8" />
      </g>
    </svg>
  </div>
</template>

<script>
// export
export default {
  // name
  name: 'BrandLines',
  // props
  props: {
    position: {
      type: String,
      default: 'center-center'
    },
    once: {
      type: Boolean,
      default: true
    },
    strokeWidth: {
      type: String,
      default: '0.2'
    },
    fillWhite: {
      type: Boolean,
      default: false
    },
    parentElement: {}
  },
  // data
  data() {
    return {
      revealed: false,
      observer: null,
      intersected: false,
      positions: {
        'center-center': 'xMidYMid meet',
        'bottom-left': 'xMinYMax slice',
        'bottom-right': 'none',
        'center-right': 'xMidYMid slice'
      }
    }
  },
  // computed
  computed: {
    animate() {
      return this.parentElement ? true : false
    },
    aspectRatio() {
      return this.positions[this.position]
    }
  },
  // watch
  watch: {
    intersected(value) {
      if (value) {
        this.initAnimes()
      } else {
        this.resetAnimes()
      }
    }
  },
  // mounted
  mounted() {
    // set observer
    if (this.animate) {
      this.setObserver()
    }
  },
  // methods
  methods: {
    /*
     * Set Observer
     */
    setObserver() {
      this.observer = new IntersectionObserver(
        entries => {
          const item = entries[0]
          var value = item.isIntersecting ? true : false
          setTimeout(() => {
            this.intersected = value
          }, 500)
        },
        { threshold: 0.5 }
      )
      const el = this.parentElement ? this.parentElement : this.$el
      this.observer.observe(el)
    },
    /*
     * Init Animes
     */
    initAnimes() {
      // exit if once and already revealed
      if (this.once && this.revealed) return
      // set as revealed
      this.revealed = true
      // handle stroke anime
      this.handleStrokeAnime()
    },
    /*
     * Handle Stroke Anime
     */
    handleStrokeAnime() {
      // handle
      const targets = this.$el.querySelectorAll('line')
      this.$anime.timeline().add({
        targets,
        strokeDashoffset: [{ value: [this.$anime.setDashoffset, 0], duration: 1000 }],
        strokeWidth: [{ value: '0', duration: 0 }, { value: this.strokeWidth, duration: 250 }],
        //strokeOpacity: [{ value: '0', duration: 0 }, { value: '1', duration: 250 }],
        easing: 'easeInQuad',
        loop: 1,
        delay: function(el, i) {
          return i * 150 + 50
        }
      })
    },
    /*
     * Reset Animes
     */
    resetAnimes() {
      // exit if once
      if (this.once) return
      // handle
      const targets = this.$el.querySelectorAll('line')
      this.$anime.timeline().add({
        targets,
        strokeWidth: 0,
        easing: 'easeInQuad',
        loop: 1
      })
    }
  }
}
</script>

<style>
.brand-lines {
  line-height: 0;
}
.brand-lines svg {
  width: 100%;
  height: 100%;
}

.brand-lines line {
  fill: none;
  stroke-width: 0.2;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
}

.brand-lines--animate line {
  /* stroke-opacity: 0; */
  stroke-width: 0;
}

.brand-lines-0 {
  stroke: #00c4b3;
}
.brand-lines-1 {
  stroke: #009877;
}
.brand-lines-2 {
  stroke: #006580;
}
.brand-lines-3 {
  stroke: #602651;
}
.brand-lines-4 {
  stroke: #960048;
}
.brand-lines-5 {
  stroke: #b32572;
}
.brand-lines-6 {
  stroke: #ff5c35;
}
.brand-lines-7 {
  stroke: #ffa400;
}

.brand-lines--fill-white svg * {
  stroke: white !important;
}
</style>
